import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  TextField,
  Button,
  Grid,
  Container,
  CircularProgress,
} from "@mui/material";

import TabletIcon from "../../../Assets/Icons/tablet-icon.png";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";
import httpclient from "../../../Utils";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const freightInitialFields = {
  freightCode: "",
};

function AddRegionalFreight() {
  const [tabIndex, setTabIndex] = useState(0);

  const [freightInfo, setFreightInfo] = useState(freightInitialFields);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const validateForm = () => {
    const rules = [
      {
        condition: !freightInfo.freightCode,
        message: "Freight Code is required",
      },
    ];

    for (const rule of rules) {
      if (rule.condition) {
        showNotification("error", rule.message);
        return false;
      }
    }
    return true;
  };

  const getFormattedData = (data) => {
    const formData = new FormData();

    const dataMap = {
      freight_code: data.freightCode,
    };

    Object.entries(dataMap).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return formData;
  };

  const handleAdd = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const endpoint = "/remote-bay-freight-code/store";

    const freightData = getFormattedData(freightInfo);

    try {
      setIsSubmitting(true);

      const res = await httpclient.post(endpoint, freightData);

      const { data } = res;

      if (data.status === 200) {
        showNotification("success", data.message);

        navigate("/regional-freight");
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      handleApiError(error, setIsSubmitting);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setFreightInfo(freightInitialFields);

    setTimeout(() => {
      navigate("/regional-freight");
    }, 100);
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="regional freight detail tabs"
          >
            <Tab
              icon={<img src={TabletIcon} alt="Tablet icon" />}
              iconPosition="start"
              label="Regional Freight Detail"
              id="tab-0"
              aria-controls="tabpanel-0"
              sx={{
                "&.Mui-selected": { color: "#7152F3" },
              }}
            />
          </Tabs>
        </Box>

        <TabPanel value={tabIndex} index={0}>
          <Box component="form" onSubmit={handleAdd} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Freight Code"
                  variant="outlined"
                  placeholder="Enter Freight Code"
                  value={freightInfo.freightCode}
                  onChange={(e) =>
                    setFreightInfo({
                      ...freightInfo,
                      freightCode: e.target.value,
                    })
                  }
                  inputProps={{ maxLength: 10 }}
                  helperText={
                    freightInfo.freightCode.length > 0
                      ? `${freightInfo.freightCode.length}/10 characters`
                      : ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{ mr: 2, textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#7152F3", textTransform: "none" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                  )}
                  {isSubmitting ? "Adding..." : "Add"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default AddRegionalFreight;
